import React from "react";
import "./carousel.css";
import features01 from "../../images/icon/features01.png"
import features02 from "../../images/icon/features02.png"
import features03 from "../../images/icon/features03.png"
const items = [
  { title: "Track your logistics expenses", desc: "See where you are spending your amount with detailed analysis", image:features01 },
  { title: "20+ Courier Partners & 29000+ Pin-codes", desc: "Cover almost all the pin-codes at affordable rates.", image:features02 },
  { title: "Give access & manage in real-time", desc: "Provide limited or full access at ease", image:features03 },
];

export default function MarqueeCarousel() {
  return (
    <div className="marquee-container">
      <div className="marquee-track">
        {[...items, ...items].map((item, i) => (
          <div className="marquee-features-card" key={i}>
            <img src={item.image} alt="" />
            <h2 className="">{item.title}</h2>
            <p className="">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
